
import { policies } from './config/policies';

const REGEXP_INTERPOLATION = /\${([a-zA-Z]+)\}/g;

function getMatches(string: string, regex: RegExp, index = 1) {
    const matches = [];
    let match;
    while (match = regex.exec(string)) {
        matches.push(match[index]);
    }
    return matches;
}

interface Statement {
    action: string[];
    effect: "Allow" | "Deny";
    resource: string[];
}


interface Params {
    account: string;
    team: string;
    region: string;
    domain: string
}

export class Policy {

    name!: string;
    description: string;
    statement: Statement[];

    constructor(policyKey: string, params: Params) {

        if (!policies[policyKey]) {
            throw new Error(`Policy ${policyKey} doesn't exists`);
        }
        this.description = policies[policyKey].description;
        this.statement = policies[policyKey].statement;

        this.buildPolicyName(policyKey, params);
        this.buildStatements(params);
    }

    buildPolicyName(policyKey: string, data: any): void {

        this.name = policies[policyKey].name.replace(REGEXP_INTERPOLATION, (prop, $1) => {
            if (data[$1]) {
                return data[$1];
            }
        });
    }

    buildStatements(data: any): void {
        this.statement = this.statement.map(_statement => {
            _statement.resource = _statement.resource.map(_resource => {
                const matches = getMatches(_resource, REGEXP_INTERPOLATION, 1);
                matches.forEach((match: string) => {
                    _resource = _resource.replace('${' + match + '}', data[match]);
                });
                return _resource;
            });
            return _statement;
        });
    }
}


